import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getUserProfile } from '../../store/slices/authSlice';

const UserProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, isLoading, user, isAdmin } = useSelector((state) => state.auth);
  
  // Check localStorage directly
  const token = localStorage.getItem('accessToken') || localStorage.getItem('userToken');
  const userData = localStorage.getItem('user');
  const isAdminAuthenticated = localStorage.getItem('isAdminAuthenticated') === 'true';

  useEffect(() => {
    // If we have token but no user data in Redux, fetch profile
    // Only fetch if we're not an admin
    if (token && !isAuthenticated && !isLoading && !user && !isAdminAuthenticated) {
      dispatch(getUserProfile());
    }
  }, [token, isAuthenticated, isLoading, user, isAdminAuthenticated, dispatch]);

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Check if admin is authenticated - redirect to admin dashboard
  if (isAdmin || isAdminAuthenticated) {
    console.log("UserProtectedRoute - Admin trying to access user routes, redirecting to admin dashboard");
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  // Check if user is authenticated (either Redux or localStorage)
  const isUserAuth = (isAuthenticated && !isAdmin) || (token && userData && !isAdminAuthenticated);

  if (!isUserAuth) {
    console.log("UserProtectedRoute - Not authenticated as user, redirecting to login");
    return <Navigate to="/user/login" state={{ from: location }} replace />;
  }

  console.log("UserProtectedRoute - User access granted");
  return children ? children : <Outlet />;
};

export default UserProtectedRoute;